import * as axios from './axios';
import i18next from './i18n';
import * as iframe from './iframe';
import logger from './logger';
import * as mercure from './mercure';
import * as roles from './roles';
import theme from './theme';
export * from './validation';
//////////////////////////////
export enum Gender {
    Homme = 'homme',
    Femme = 'femme',
}

export * from './sorting';

export { axios, i18next, iframe, logger, mercure, roles, theme };
